import * as React from 'react';
import {
  Button,
  makeStyles,
  tokens,
  Title1,
  Title3,
  Text,
} from '@fluentui/react-components';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft24Regular } from '@fluentui/react-icons';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: tokens.spacingHorizontalXXL,
    textAlign: 'center',
    backgroundColor: tokens.colorNeutralBackground1,
  },
  content: {
    maxWidth: '600px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: tokens.spacingVerticalXL,
  },
  errorCode: {
    fontSize: tokens.fontSizeHero900,
    fontWeight: tokens.fontWeightBold,
    color: tokens.colorPaletteRedForeground1,
    margin: 0,
  },
  title: {
    color: tokens.colorNeutralForeground1,
    margin: 0,
  },
  description: {
    color: tokens.colorNeutralForeground2,
    fontSize: tokens.fontSizeBase300,
    lineHeight: tokens.lineHeightBase300,
    maxWidth: '400px',
  },
  actions: {
    display: 'flex',
    gap: tokens.spacingHorizontalM,
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  primaryButton: {
    minWidth: '140px',
  },
  secondaryButton: {
    minWidth: '140px',
  },
});

const NotFound: React.FC = () => {
  const styles = useStyles();
  const navigate = useNavigate();

  const handleGoToLogin = () => {
    navigate('/login');
  };

  const handleGoBack = () => {
    // Tenta voltar para a página anterior, se não conseguir vai para o login
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/login');
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Title1 className={styles.errorCode}>404</Title1>

        <div>
          <Title3 className={styles.title}>Página não encontrada</Title3>
          <Text className={styles.description}>
            A página que você está procurando não existe ou foi movida.
            Verifique se o endereço está correto ou volte para a página inicial.
          </Text>
        </div>

        <div className={styles.actions}>
          <Button
            appearance="primary"
            size="large"
            onClick={handleGoToLogin}
            className={styles.primaryButton}
          >
            Ir para Login
          </Button>
          <Button
            appearance="outline"
            size="large"
            icon={<ArrowLeft24Regular />}
            onClick={handleGoBack}
            className={styles.secondaryButton}
          >
            Voltar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;